import { ReactNode, useEffect, useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';

import { SupplierLogo } from 'components/OrderForms/SupplierLogo/SupplierLogo';

import { HeaderSection } from './components/HeaderSection';
import { LanguageSwitcher } from './components/LanguageSwitcher';
import { ProfileMenu } from './components/ProfileMenu';

export const Header = ({ rightContent }: { rightContent?: ReactNode }) => {
  const headerRef = useRef<HTMLElement>(null);
  const { height = 0 } = useResizeObserver({
    ref: headerRef as React.RefObject<HTMLElement>,
    box: 'border-box',
  });

  useEffect(() => {
    document.documentElement.style.setProperty('--order-form-header-height', `${height}px`);
    return () => {
      document.documentElement.style.removeProperty('--order-form-header-height');
    };
  }, [height]);

  return (
    <header
      ref={headerRef}
      className="sticky inset-x-0 top-0 z-10 flex items-center justify-between bg-white px-8 py-4"
    >
      <HeaderSection>
        <SupplierLogo size="small" />
        <LanguageSwitcher />
      </HeaderSection>
      <HeaderSection>
        {rightContent ? rightContent : null}
        <ProfileMenu />
      </HeaderSection>
    </header>
  );
};
